/**
 * Fuente única del canal de contacto y del horario de atención.
 *
 * El número y el horario estaban duplicados en varios componentes; centralizarlos
 * aquí evita que el widget y el indicador de disponibilidad diverjan.
 */

export const WHATSAPP_NUMBER = "50761568575";

export const WHATSAPP_DEFAULT_MESSAGE =
  "¡Hola! Me gustaría obtener más información sobre sus agendas.";

export const BUSINESS_HOURS = {
  startHour: 8,
  endHour: 20,
  timeZone: "America/Panama",
} as const;

export type BusinessHours = {
  startHour: number;
  endHour: number;
  timeZone: string;
};

/** Franjas del horario preferido para "solicitar llamada". */
export const PREFERRED_SCHEDULES = [
  { value: "manana", label: "Mañana (8:00–12:00)" },
  { value: "tarde", label: "Tarde (12:00–17:00)" },
  { value: "noche", label: "Noche (17:00–20:00)" },
] as const;

export const PREFERRED_SCHEDULE_VALUES = [
  "manana",
  "tarde",
  "noche",
] as const;

export type PreferredSchedule = (typeof PREFERRED_SCHEDULE_VALUES)[number];

/** Etiqueta legible de una franja (fuente única: PREFERRED_SCHEDULES). */
export const preferredScheduleLabel = (value?: string): string =>
  PREFERRED_SCHEDULES.find((schedule) => schedule.value === value)?.label ?? "";